{
	"title": "Atrybuty wychwyconego CO\u2082",
	"buttonTitle": "Wychwyt i składowanie CO\u2082",
	"table": {
		"materialDescription": "Materiał",
		"quantity": "Ilość",
		"productGwpTotal": "Całkowity GWP produktu",
		"bundledCarbonReductions": "Zbundlowane redukcje emisji CO\u2082",
		"remainingGwp": "Pozostały GWP",
		"epdForPhysicalMaterial": "EPD dla materiału fizycznego",
		"carbonPlantName": "Brevik, Norwegia"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "jest prawowitym posiadaczem zgłoszonych redukcji emisji CO\u2082."
	},
	"modal": {
		"title": "Wychwyt i składowanie CO\u2082",
		"description": "Carbon Capture and Storage (CCS) to technologia umożliwiająca wychwytywanie emisji dwutlenku węgla (CO2) powstających w procesie kalcynacji oraz podczas spalania paliw w piecu, zapobiegając przedostawaniu się CO2 do atmosfery i trwale magazynując go pod ziemią. Wychwycony CO2 z zakładu Heidelberg Materials w Brevik (Norwegia) jest sprężany i transportowany do miejsca składowania pod Morzem Północnym. Instalacja w naszym zakładzie w Brevik będzie wychwytywać 400\u00a0000 ton CO2 rocznie.",
		"showLink": "Dowiedz się więcej o procesie wychwytu CO\u2082",
		"buttonClose": "Zamknij"
	},
	"footnote": "1) Redukcje emisji CO\u2082 kompensują etapy A1-A3 inwentaryzacji cyklu życia cementu."
}
